<template>
  <div class="grid grid-flow-col auto-cols-min gap-[75px] font-semibold text-white text-[36px]">
    <div>
      <input
        id="language-en"
        type="radio"
        v-model="$i18n.locale"
        value="en"
        class="appearance-none"
      >
      <label
        for="language-en"
        class="py-4 cursor-pointer"
        :class="{ 'border-b-[4px]': $i18n.locale === 'en' }"
      >
        English
      </label>
    </div>
    <div>
      <input
        id="language-es"
        type="radio"
        v-model="$i18n.locale"
        value="es"
        class="appearance-none"
      >
      <label
        for="language-es"
        class="py-4 cursor-pointer"
        :class="{ 'border-b-[4px]': $i18n.locale === 'es' }"
      >
        Español
      </label>
    </div>
  </div>
</template>
